var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isLoggedIn)?_c(_setup.BasicButton,{attrs:{"blocked":true,"color":"tertiary"},on:{"click":_setup.openModal}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('WEBAPP_LOGINS_SIGNIN_CTA'))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }